import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ Check for Supabase session before allowing password reset
  useEffect(() => {
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);
      setLoading(false);
    };
    getSession();
  }, []);

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) {
      setError("Please fill in both fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!session) {
      setError("Session expired. Please request another password reset.");
      return;
    }

    const { error } = await supabase.auth.updateUser({
      password,
    });

    if (error) {
      setError(`Error resetting password: ${error.message}`);
    } else {
      alert("Password reset successful! You can now log in.");
      navigate('/login');
    }
  };

  if (loading) {
    return <div className="reset-container"><p>Loading reset session...</p></div>;
  }

  return (
    <div className="reset-container">
      <div className="reset-box">
        <h2>Reset Your Password</h2>
        {error && <p className="reset-error">{error}</p>}
        <input 
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="reset-input"
        />
        <input 
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="reset-input"
        />
        <button className="reset-button" onClick={handleResetPassword}>Set New Password</button>
      </div>
    </div>
  );
};

export default ResetPassword;
